import { render, staticRenderFns } from "./AccountNeedsVerificationModal.vue?vue&type=template&id=a2e52136&scoped=true"
import script from "./AccountNeedsVerificationModal.vue?vue&type=script&lang=js"
export * from "./AccountNeedsVerificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e52136",
  null
  
)

export default component.exports